export const survey = {
  id: 2,
  variety: 0,
  variety_formatted: "CLEAR Screen",
  status: 0,
  name: "CLEAR Screen",
  created_at: "2020-05-11T16:30:58.000+00:00",
  updated_at: "2020-05-11T16:30:58.000+00:00",
  created_by_id: 1,
  instruction_text: "Take the CLEAR Screen.",
  version_count: 2,
  allow_multiple_targets: false,
  allow_multiple_evaluators: false,
};

export const surveyVersions = [
  {
    id: 2,
    number: 1,
    created_at: "2020-05-11T16:30:58.000+00:00",
    created_by_id: 1,
    active: false,
    question_count: 173,
  },
  {
    id: 3130,
    number: 2,
    name: "V2 ",
    created_at: "2022-02-23T15:31:48.000+00:00",
    created_by_id: 1,
    active: true,
    question_count: 173,
  },
];
